import apiMethods from "../utils/api";
import { storeAuthToken, removeStoredAuthToken } from "../utils/authToken";

interface LoginCredentials {
    username: string;
    password: string;
}

interface ForgotPasswordRequest {
    email: string;
}

interface ResetPasswordRequest {
    token: string;
    new_password: string;
    confirm_password: string;
}

interface ChangePasswordRequest {
    username: string;
    old_password: string;
    new_password: string;
    new_password_confirm: string;
}

export const authService = {
    login: async (credentials: LoginCredentials) => {
        try {
            const response = (await apiMethods.post(
                "/token/",
                credentials
            )) as { access: string, force_change_password: boolean };
            if (response.force_change_password === true) {
                return { access: response.access, force_change_password: true };
            }
            if (!response.access) {
                throw new Error("No access token received");
            }
            storeAuthToken(response.access);
            return response;
        } catch (error: any) {
            removeStoredAuthToken();
            throw new Error("Invalid credentials");
        }
    },

    logout: () => {
        removeStoredAuthToken();
    },

    refreshToken: async (refresh: string) => {
        try {
            const response = (await apiMethods.post("/token/refresh/", {
                refresh,
            })) as { access: string };
            if (!response.access) {
                throw new Error("No access token received");
            }
            storeAuthToken(response.access);
            return response.access;
        } catch (error) {
            removeStoredAuthToken();
            throw error;
        }
    },

    forgotPassword: async (data: ForgotPasswordRequest) => {
        return await apiMethods.post("/users/forgot-password/", data);
    },

    resetPassword: async (data: ResetPasswordRequest) => {
        return await apiMethods.post("/users/reset-password/", data);
    },

    changePassword: async (data: ChangePasswordRequest) => {
        return await apiMethods.post("/users/change-password/", data);
    },
};
